// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"ce8536a9","257":"b971d1cf","358":"9173ca11","727":"3b4c48ef"}[chunkId] + ".chunk.js";
};